export const customFieldsGroupWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const customFieldsGroupTitleStyles = {
  display: 'block',
};

export const customFieldsGroupGridStyles = numberOfColumns => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${numberOfColumns}, minmax(0, 1fr))`,
  columnGap: '12px',
  rowGap: '12px',
});

export const customFieldCellStyles = span => ({
  gridColumn: `span ${span}`,
});
